<button class="cursor-pointer bg-primary px-5 py-2 rounded text-center drop-shadow-lg w-full" type="submit">
  <fa-icon *ngIf="_icon" [icon]="_icon" class="pr-1.5"></fa-icon>
  {{_text}}
</button>
